import { environment } from 'src/environments/environment';
import { consumeUiSessionHandoffCookie } from './ui-session-handoff-cookie.util';

export const CLASSIC_HANDOFF_PARAM = 'classicHandoff';

const STATIC_ALLOWLIST = new Set([
  'token',
  'refresh_token',
  'token-key',
  'username',
  'userLocalStorageToken',
  'subdomain',
  'email',
  'identityprovider',
  'currentTheme',
]);

const DENYLIST = new Set([
  'logout-event',
  'login-event',
  'addUrlToCache',
  'addLoginFlag',
  'loginAttemptCount',
]);

/** Apply new UI session before classic bootstrap when returning from predev. */
export function acceptClassicSessionFromHandoff(): void {
  const currentUrl = new URL(window.location.href);
  if (currentUrl.searchParams.get(CLASSIC_HANDOFF_PARAM) !== '1') {
    return;
  }

  currentUrl.searchParams.delete(CLASSIC_HANDOFF_PARAM);
  const nextUrl = `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`;
  history.replaceState(null, '', nextUrl);

  const payload = consumeUiSessionHandoffCookie();
  if (!payload?.storage?.token) {
    return;
  }

  applyHandoffStorage(payload.storage);
}

function isAllowedKey(key: string): boolean {
  if (!key || DENYLIST.has(key)) {
    return false;
  }
  if (STATIC_ALLOWLIST.has(key)) {
    return true;
  }
  return key.endsWith('-key');
}

function applyHandoffStorage(storage: Record<string, string>): void {
  for (const [key, value] of Object.entries(storage)) {
    if (!isAllowedKey(key) || typeof value !== 'string') {
      continue;
    }
    localStorage.setItem(key, value);
  }

  const authKey = `${environment.appVersion}-${environment.USERDATA_KEY}`;
  if (localStorage.getItem(authKey) || !localStorage.getItem('token')) {
    return;
  }

  const refreshToken = localStorage.getItem('refresh_token') ?? '';
  let account = localStorage.getItem('subdomain') ?? '';
  try {
    const tokenKey = JSON.parse(localStorage.getItem('token-key') || 'null');
    account = String(tokenKey?.account ?? account).trim().toLowerCase();
  } catch {
    // keep subdomain
  }

  localStorage.setItem(
    authKey,
    JSON.stringify({
      token: localStorage.getItem('token'),
      refresh_token: refreshToken,
      account,
    }),
  );
}
